import { render, staticRenderFns } from "./RolesPermissions.vue?vue&type=template&id=41d6d3fe&"
import script from "./RolesPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesPermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolesPermissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports